<template>
    <sup> {{ text }}</sup>
    <!-- <client-only>
        <sup v-if="referenceModel">
            <a :id="`p-ref${referenceModel?.elements.referenceOrderNumber.value}`" @click="scrollToElement(
                `ref${referenceModel?.elements.referenceOrderNumber.value}`,
                130
            )">
                {{ text }}
            </a>
        </sup>
        <sup v-else>{{ text }}</sup>
    </client-only> -->
</template>
<script lang="ts" setup>
// import type {
//     ReferenceModel
// } from '~/models';

const { scrollToElement } = useSmoothScroll()
const props = defineProps<{
    text: string,
}>()

const pageStore = usePageStore()
// const referenceModel = ref<ReferenceModel | null>(null)

// referenceModel.value = pageStore.getPageReferences()[props.text.trim()] as ReferenceModel

// if (referenceModel.value)
//     await pageStore.addReference(referenceModel.value.system.id)
</script>
<style scoped>
sup {
    cursor: pointer;
}
a {
    color: var(--theme-color) !important;
    text-decoration: underline !important;
}
</style>
